import { render, staticRenderFns } from "./AddPptResource.vue?vue&type=template&id=2c0f631b&scoped=true&"
import script from "./AddPptResource.vue?vue&type=script&lang=js&"
export * from "./AddPptResource.vue?vue&type=script&lang=js&"
import style0 from "./AddPptResource.vue?vue&type=style&index=0&id=2c0f631b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0f631b",
  null
  
)

export default component.exports